import { categoryDetailLinkListStyles } from "@insite/content-library/Widgets/Category/CategoryDetailLinkList";
import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { css } from "styled-components";

categoryDetailLinkListStyles.container = {
    gap: 0,
    css: css`
        background: #f6f6f6;
        border: 1px solid #e1e1e1;
        padding: 10px;
        margin-bottom: 10px;
    `,
};

categoryDetailLinkListStyles.subCategoryNameLink = {
    css: css`
        overflow: hidden;
    `,
    typographyProps: {
        css: css`
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `,
    },
};

categoryDetailSubCategoriesStyles.subCategoryItem = {
    width: [12, 12, 4, 4, 3],
    css: css`
        padding: 0 10px 30px 10px;
    `,
};
